import { getAuthBaseUrl } from '@src/utility/serverUrls'

const baseUrl = getAuthBaseUrl()
//baseUrl = 'http://localhost:8004'

// ** Auth Endpoints
export default {
  loginEndpoint: `${baseUrl}/loginv2`,
  registerEndpoint: '/jwt/register',
  refreshEndpoint: `${baseUrl}/token`,
  logoutEndpoint: `${baseUrl}/logout`,

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken'
}
